import React, { useState } from "react";
import { Button, Tag, Tooltip } from "antd";
import { useDispatch } from "react-redux";
import { actions as experienceUserActions } from "views/ExperienceUsers/redux";
import { formatJsonApiData } from "mr_react_framework";
import ResponseAttachments from "views/Segments/ResponseAttachments/ResponseAttachments";
import { showConfirmModal } from "./Segment/UIHelper";
import { useTranslate } from "lib/MrTranslate/MrTranslate";

const ViewUploadsModal = ({ count = null, item = {}, type = "", shape = "", size = "", buttonText = "", icon = null }) => {
  console.log("ViewUploadsModal ==>", { count, item, type, shape, size, icon })
  const [isModalOpen, setIsModalOpen] = useState(false);
  const mrIntl = useTranslate()

  const dispatch = useDispatch();
  const uploadButtonStyle = {
    padding: 0, 
    width: "100%", 
    textAlign: "left"
  }

  const submitAttachments = (
    attachments_json,
    submitAttachmentsStartCallback,
      submitAttachmentsCompletedCallback
  ) => {
    console.log(
      "submit attachments ==>",
      attachments_json,
      submitAttachmentsCompletedCallback
    );
    submitAttachmentsStartCallback();
    dispatch(
      experienceUserActions.submitAttachments(
        {
          id: item.id,
          experience_id: item.experience_id,
          user_id: item.user_id,
          uploads_allowed: true,
          attachments_count:
            attachments_json.attachments && attachments_json.attachments.length,
          attachments_json: attachments_json,
        },
        {
          success: {
            showMessage: true,
            message: "Files submitted successfully.",
          },
          successCallback: (response) => {
            const finalExperienceUser = formatJsonApiData(
              response.data.experience_user
            );
            const updatedExperienceUser = {
              ...item,
              ...finalExperienceUser,
            };
            console.log(
              "response after upload =>",
              item,
              response,
              finalExperienceUser,
              updatedExperienceUser
            );
            dispatch(
              experienceUserActions.showSuccess(
                { data: { experience_user: updatedExperienceUser } },
                { success: { showMessage: false } }
              )
            );
            submitAttachmentsCompletedCallback(response);
            setIsModalOpen(false);
          },
          errorCallback: (error) => {
            submitAttachmentsCompletedCallback(error);
          },
        }
      )
    );
  };

  const handleSubmitAttachments = (
    attachmentsJson,
    submitAttachmentsStartCallback,
    submitAttachmentsCompletedCallback
  ) => {
    showConfirmModal({
      centered: true,
      title: mrIntl("ViewUploadsModal.submitting_attachments"),
      content: mrIntl("ViewUploadsModal.are_you_sure_you_want_to_submit_these_files_these"),
      onOk: () => {
        submitAttachments(
          attachmentsJson,
          submitAttachmentsStartCallback,
          submitAttachmentsCompletedCallback
        );
      },
      onCancel: () => {},
      mrIntl: mrIntl
    });
  };

  const handleCloseModal = (changed) => {
    if (changed) {
      showConfirmModal({
        centered: true,
        title: mrIntl("ViewUploadsModal.cancel_submission"),
        content:
          mrIntl("ViewUploadsModal.some_attachments_are_not_saved_are_you_sure_you_wish"),
        onOk: () => {
          setIsModalOpen(false);
        },
        mrIntl: mrIntl
      });
    } else {
      setIsModalOpen(false);
    }
  };

  const responseAttachments = (
    <ResponseAttachments
      answerMode={true}
      previewType={"modal"}
      maxAttachments={100}
      recordId={item.experience_id}
      userId={item.user_id}
      modalVisible={isModalOpen}
      attachments_json={item.attachments_json}
      deleteNotAllowedMessage={true}
      onSubmit={handleSubmitAttachments}
      closeModal={handleCloseModal}
      disableUploader={item.marked}
      disabledUploaderTooltip={mrIntl("ViewUploadsModal.please_unpublish_the_result_to_upload")}
    />
  );

  return (
    <React.Fragment>
      {isModalOpen && responseAttachments }

      <Button
        onClick={() => setIsModalOpen(true)}
        type={type}
        shape={shape}
        size={size}
        icon={icon}
        style={buttonText !== "" ? uploadButtonStyle : {}}
      >
        <Tooltip title="Total uploads" placement="bottom">
          {count && <Tag>{count}</Tag>}
        </Tooltip>
        {buttonText}
      </Button>

    </React.Fragment>
  );
};

export default ViewUploadsModal;
